import React from "react";
import { Row, Col, Typography, Card } from "antd";
import jiuJitsuImg from "../../assets/jiu.png";
import p1 from "../../assets/p1.jpg";
import p2 from "../../assets/p2.jpg";
import p3 from "../../assets/p3.png";
import p4 from "../../assets/p4.jpg";
import downloadIcon from "../../assets/download.png";

const { Title, Paragraph } = Typography;

export default function JiuJitsuAbout() {
  const pastHighlights = [p1, p2, p3, p4];

  const containerStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    backgroundColor: "transparent",
    padding: "60px 0",
    marginTop: "-70px",
  };

  const sectionStyle = {
    width: "100%",
    maxWidth: "1200px",
    margin: "0 auto 80px auto",
    padding: "0 40px",
  };

  const headingStyle = {
    fontSize: "32px",
    fontWeight: "700",
    color: "#000",
    marginBottom: "40px",
    textAlign: "left",
    paddingLeft: "0",
  };

  const contentStyle = {
    fontSize: "16px",
    color: "#333",
    lineHeight: "1.8",
    textAlign: "left",
    marginLeft: "0",
  };

  return (
    <div style={containerStyle}>

      {/* About Section */}
      <div style={sectionStyle}>
        <Card
          style={{ 
            border: "none", 
            borderRadius: "16px",
          }}
        >
          <Row gutter={[48, 32]} align="middle">
            <Col xs={24} md={12}>
              <div style={{ paddingRight: "20px" }}>
                <Title 
                  level={2} 
                  style={{ 
                    color: "#480558", 
                    textAlign: "left",
                    marginBottom: "24px",
                    fontSize: "28px",
                    fontWeight: "700",
                  }}
                >
                  About the Jiu-Jitsu Tournaments
                </Title>
                <Paragraph style={contentStyle}>
                  Yalla Nellab hosts friendly and competitive Jiu-Jitsu tournaments 
                  for workers, companies, schools and open-community teams. 
                  Whether you're a beginner or a trained athlete, our jiu-jitsu 
                  events give everyone a chance to participate, learn and grow.
                </Paragraph>
              </div>
            </Col>
            <Col xs={24} md={12}>
              <img
                src={jiuJitsuImg}
                alt="Jiu-Jitsu"
                style={{
                  width: "70%",
                  borderRadius: "12px",
                  objectFit: "cover",
                  marginLeft: "100px",
                }}
              />
            </Col>
          </Row>
        </Card>
      </div>

      {/* Upcoming Tournaments Section - No Events */}
      <div style={sectionStyle}>
        <h2 style={headingStyle}>
          Upcoming Tournaments
        </h2>

        <Card
          style={{
            backgroundColor: "#F8F8F8",
            border: "none",
            width: "100%",
            height: "200px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderRadius: "12px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
          }}
        >
          <span style={{ 
            color: "#6D6D6D", 
            fontSize: "18px", 
            fontWeight: "500" 
          }}>
            No Events yet (Coming Soon)
          </span>
        </Card>
      </div>

      {/* Past Tournaments Highlights Section */}
      <div style={sectionStyle}>
        <h2 style={headingStyle}>
          Past Tournaments Highlights
        </h2>

        <div
          style={{
            display: "flex",
            gap: "24px",
            flexWrap: "wrap",
            justifyContent: "flex-start",
          }}
        >
          {pastHighlights.map((img, idx) => (
            <div 
              key={idx} 
              style={{ 
                flex: "0 0 calc(25% - 18px)",
                minWidth: "250px"
              }}
            >
              <img
                src={img}
                alt={`Past Highlight ${idx + 1}`}
                style={{
                  width: "100%",
                  height: "220px",
                  objectFit: "cover",
                  borderRadius: "12px",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                }}
              />
            </div>
          ))}
        </div>
      </div>

      {/* Tournament Structure Section */}
      <div style={sectionStyle}>
        <h2 style={headingStyle}>
          Tournament Structure
        </h2>
        <div style={contentStyle}>
          1. Matches follow standard Jiu-Jitsu rules and weight classes.<br />
          2. Competitors are grouped by skill level and age categories.<br />
          3. Each match has a time limit, with referees ensuring fair play.<br />
          4. Participants must present valid ID and registration confirmation.<br />
          5. Respect, sportsmanship and discipline are strictly enforced — violations may lead to penalties or disqualification.
        </div>
      </div>

      {/* Download Rule Book Button */}
      <div style={{...sectionStyle, marginBottom: "40px" }}>
        <button
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "12px",
            padding: "16px 24px",
            width: "300px",
            backgroundColor: "#ffffff", 
            color: "#000000", 
            fontSize: "16px",
            fontWeight: "600",
            border: "2px solid #A3A3A3",
            borderRadius: "8px",
            cursor: "pointer",
            marginLeft: "0",
          }}
          onClick={() => {}}
        >
          <img
            src={downloadIcon}
            alt="Download Icon"
            style={{ width: "24px", height: "24px" }}
          />
          <span>Download Rule Book</span>
        </button>
      </div>

    </div>
  );
}